import { BaseNotification } from '@notify/models/notification/types/base';

export class DocumentsUpdate extends BaseNotification {
  constructor(data) {
    super(data);
  }

  static STATUS_APPROVED = 'approved';
  static STATUS_REJECTED = 'rejected';

  getTheme() {
    const { status } = this.params;
    return status === DocumentsUpdate.STATUS_APPROVED
      ? BaseNotification.THEME_SUCCESS
      : BaseNotification.THEME_ERROR;
  }

  getI18nProps() {
    const { status } = this.params;
    return {
      path: `notify.notification.documents_update.body.${status}`
    };
  }
}
